<template>
  <div id="app">
   
   <router-view></router-view>
 
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
  data() {
    return {
     
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  
}
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  .floatWindow {
    width: 100%;
    min-width: 1130px;
    margin: 0 auto;
    font-size: 13px;
    text-align: center;
    padding: 8px 0px;
    color: #ff9b1c;
    background-color: rgba(240, 215, 132, 0.4);
    img {
      cursor: pointer;
    }
  }
}
ul {
  padding-left: 0;
  margin: 0 auto;
}
ul li {
  padding-left: 0px;
  list-style: none;
}
p {
  margin: 0;
}
a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
.path {
  stroke: #e90013 !important;
}

@media screen and (max-width: 500px) {
  body {
    overflow-x: hidden;
  }
}
</style>
